export default "__VITE_ASSET__D$AyE9WF__"